import { EntityName } from '@adm/backend-entity';

import { DefaultAction, Models, UserRole } from '../../enums';

const Actions = {
  ...DefaultAction,
};

export const providerPermissions: Record<
  UserRole,
  { actions: Array<keyof typeof Actions>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    { actions: [Actions.read, Actions.create, Actions.update], subject: Models.Provider },
    { actions: [Actions.read], subject: Models.Providers },
  ],

  [UserRole.Operator]: [
    { actions: [Actions.read], subject: Models.Provider },
    { actions: [Actions.read], subject: Models.Providers },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    { actions: [Actions.read], subject: Models.Provider },
    { actions: [Actions.read], subject: Models.Providers },
  ],

  [UserRole.DeviceOperator]: [],

  [UserRole.OperatorReadAccess]: [
    { actions: [Actions.read], subject: Models.Provider },
    { actions: [Actions.read], subject: Models.Providers },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [],
};
